// src/components/Magazine/Michelangelo.js
import React, {useState} from 'react';
import CloseIcon from '@mui/icons-material/Close';

import '../../styles/magazineGallery.scss';

function Gmaro() {
  /*Costruire react things */
    let data=[
        {
            id: 1,
            imgSrc: '/images/GMARO/GMARO_3.jpg',
        },
        {
            id: 2,
            imgSrc: '/images/GMARO/GMARO_2.jpg',
        },
        {
            id: 3,
            imgSrc: '/images/GMARO/GMARO_1.jpg',
        },
        {
            id: 4,
            imgSrc: '/images/GMARO/GMARO_4.jpg',
        },
        {
            id: 5,
            imgSrc: '/images/GMARO/GMARO_5.jpg',
        },
        
    ]
    const [model, setModel] = useState(false);
    const [tempimgSrc, setTempImgSrc] = useState('');
    const getImg = (imgSrc) =>{
        setTempImgSrc(imgSrc);
        setModel(true);
    }
  return (
    <>
    <div className={model ? "model open" : "model"}>
        <img src={tempimgSrc} alt="Gmaro" />
        <CloseIcon onClick={()=> setModel(false)} />
    </div>
        <div className="gallery">
            {data.map((item, index)=>{
                return(
                    <div className='pics' key={index} onClick={()=> getImg(item.imgSrc)}>
                        <img src={item.imgSrc} alt="Gmaro" style={{width: '100%'}} loading="lazy"  />
                     </div>
                )
            })}
        </div>
     
    </>
  );
}

export default Gmaro;
